<template>
<MainLayout501 selectMenu="1-1" sideBar="machine" siderMenu="501-2">
    <Tabs v-model="selectTab" type="card" class="custom-tabs">
        <TabPane label="规范" name="m1" class="custom-tabpane">
            <Specification v-if="selectTab === 'm1'" :mac="mac"></Specification>
        </TabPane>
        <TabPane label="电极1修磨" name="m2" class="custom-tabpane">
            <CountingOne v-if="selectTab === 'm2'" :mac="mac"></CountingOne>
        </TabPane>
         <TabPane label="电极2修磨" name="m3" class="custom-tabpane">
            <CountingTwo v-if="selectTab === 'm3'" :mac="mac"></CountingTwo>
        </TabPane>
        <TabPane label="电极1计数" name="m4" class="custom-tabpane">
            <GrindingOne v-if="selectTab === 'm4'" :mac="mac"></GrindingOne>
        </TabPane>
        <TabPane label="电极2计数" name="m5" class="custom-tabpane">
            <GrindingTwo v-if="selectTab === 'm5'" :mac="mac"></GrindingTwo>
        </TabPane>
    </Tabs>
</MainLayout501>
</template>

<script>
import MainLayout501 from '@/components/501/MainLayout.vue'
import Specification from './components/Specification.vue'
import CountingOne from './components/CountingOne.vue'
import CountingTwo from './components/CountingTwo.vue'
import GrindingOne from './components/GrindingOne.vue'
import GrindingTwo from './components/GrindingTwo.vue'

export default {
    name: 'ProductionIndex',
    components: {
        MainLayout501, Specification, CountingOne, CountingTwo, GrindingOne, GrindingTwo
    },
    data() {
        return {
            mac: '',
            selectTab: "m1",
        }
    },
    watch: {
        selectTab(newVal) {
            if (newVal) {
                localStorage.setItem('production501.selectTab', newVal);
            }
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac || '';
            this.selectTab = localStorage.getItem('production501.selectTab') || 'm1';
        },
    }
}
</script>

<style scoped>
@import url('../../../assets/style/tab.css');
</style>
